import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_onboarding-top_promo_banner-view';
/**
 * Records top promo banner viewed
 */
export function trackRetailerOnboardingTopPromoBannerView(Promo_Banner_Name_string) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { Promo_Banner_Name_string },
    });
}
